import React from "react";
import PropTypes from "prop-types";
import SmartTag from "../../utils/TagHandler";
import Link from "../Global/Link";
import PlatformLinks from "../Global/PlatformLinks";
import Image from "../Global/Image";
import Background from "../Global/Background";

const CardSignature = (props) => {
  const { item } = props;

  return (
    <>
      {item ? (
        <div className="d-flex flex-column justify-content-center align-items-center text-center h-100">
          {item.image?.filename && (
            <Image
              src={item.image?.filename}
              alt={item.title && item.title}
              sm="0x100"
              md="0x140"
              lg="0x190"
              className="mx-auto mb-3"
            />
          )}
          {item.title && (
            <h5 className="fw-bold mb-3 text-center">{item.title}</h5>
          )}

          <div className="d-flex flex-row align-items-center mb-3">
            {item?.icon?.content && (
              <>
                <Image
                  src={item.icon.content.image?.filename}
                  alt={item.icon.content.title}
                  sm={`34x34`}
                  md={`34x34`}
                  lg={`34x34`}
                  className="me-2"
                />
                {item.icon.content.title}
              </>
            )}
          </div>

          {item.link && (
            <div className="mt-auto">
              <Link to={item.link} button icon>
                Buy
              </Link>
            </div>
          )}
        </div>
      ) : (
        <div className="brand-radius brand-background-black brand-text-white w-100 h-100 d-flex justify-content-center align-items-center">
          Asset not set
        </div>
      )}
    </>
  );
};

export default CardSignature;

CardSignature.propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.string,
};

CardSignature.defaultProps = {
  item: null,
  size: "1x1",
};
